import { IconWrapper } from "@insite/mobius/Icon";
import { accountTilesStyles } from "@pace/App/Widgets/AccountTiles/AccountTiles";
import IconArrowRight from "@pace/XDL/Icons/IconArrowRight";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, createLinkIconStyles, sharedContainerStyles, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

accountTilesStyles.spinnerWrapper = {
    ...sharedContainerStyles?.centeringContent,
};

accountTilesStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 16px;
        ${xScreen("lt", "sm")} {
            margin-bottom: 21px;
        }
    `,
};

accountTilesStyles.titleSection = {
    css: css`
        display: flex;
        font-size: 20px;
        line-height: 26px;
        font-weight: ${fontConfig.weight.bold};
        gap: 5px;
        ${xScreen("lt", "sm")} {
            padding-bottom: 5px;
        }
    `,
};

accountTilesStyles.tilesContainer = {
    gap: 22,
};

accountTilesStyles.tileItem = {
    width: [12, 6, 6, 3, 3],
    css: css`
        ${xScreen("lt", "sm")} {
            padding-block: 6px;
        }
    `,
};

accountTilesStyles.itemContainer = {
    css: css`
        display: flex;
        flex: 1;
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        background-color: ${color("white")};
        gap: 12px;
        padding: 5px;
    `,
};

accountTilesStyles.itemInfoWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding-bottom: 4px;
        margin-top: auto;
    `,
};

accountTilesStyles.item = {
    titleContainer: {
        css: css`
            display: flex;
            gap: 8px;
            align-items: center;
            min-height: 40px;
        `,
    },
    title: {
        variant: "h5",
        forwardAs: "h2",
        css: css`
            margin: 0;
        `,
    },
    number: {
        variant: "h1",
        css: css`
            margin: 0;
        `,
    },
    imageWrapper: {
        css: css`
            display: flex;
            width: 73px;
            height: 73px;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            background-color: ${color("primary")};
        `,
    },
    image: {
        width: "37px",
        height: "37px",
        css: css`
            & > img {
                height: 100%;
            }
        `,
    },
    link: {
        ...createLinkIconStyles(IconArrowRight, {
            typographyProps: {
                size: 12,
                lineHeight: "17px",
            },
            css: css`
                justify-content: left;
                ${IconWrapper} {
                    &,
                    > svg {
                        width: 11px;
                        height: auto;
                    }
                }
            `,
        }),
    },
};
